import React from 'react';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import MoneyIcon from '@mui/icons-material/Money';
import GroupIcon from '@mui/icons-material/Group';
import SchoolIcon from '@mui/icons-material/School';
import AnalyticsPageLayout from '../components/analytics/AnalyticsPageLayout';
import KpiCard from '../components/dashboard/KpiCard';
import useFetchAnalytics from '../hooks/useFetchAnalytics';
import Spinner from '../components/spinner/Spinner';
import { VerticalBar } from '../components/charts/VerticalBar';

const CHART_CARD = 'bg-white rounded-xl border border-gray-200 shadow-sm p-4';

function PaidModulesAnalytics() {
  const {
    data: paidModulesAnalyticsData,
    isLoading: isLoadingPaidModulesAnalytics,
  } = useFetchAnalytics(
    ['paid-modules-analytics'],
    '/paid-modules-analytics',
    {},
    "Couldn't get paid modules analytics. Please try again",
    true
  );

  const analytics = paidModulesAnalyticsData?.data;

  return (
    <AnalyticsPageLayout
      title="Paid Modules Analytics"
      description="Paid module enrolment and revenue generated."
    >
      {isLoadingPaidModulesAnalytics ? (
        <div className="flex items-center justify-center bg-white rounded-xl border border-gray-200 shadow-sm py-10">
          <Spinner />
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
            <KpiCard
              title="Revenue (USD)"
              value={analytics?.total_revenue_in_usd ?? 0}
              icon={<AttachMoneyIcon fontSize="inherit" />}
              iconColour="#00999E"
            />
            <KpiCard
              title="Revenue (KES)"
              value={analytics?.total_revenue_in_kes ?? 0}
              icon={<MoneyIcon fontSize="inherit" />}
              iconColour="#00999E"
            />
            <KpiCard
              title="Student enrolments"
              value={analytics?.total_student_enrollment ?? 0}
              icon={<GroupIcon fontSize="inherit" />}
              iconColour="#8B173B"
            />
            <KpiCard
              title="Paid modules"
              value={analytics?.total_paid_modules ?? 0}
              icon={<SchoolIcon fontSize="inherit" />}
              iconColour="#8B173B"
            />
          </div>
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
            {analytics?.modules_usd_revenue_graphs_data && (
              <div className={`${CHART_CARD} h-[320px]`}>
                <VerticalBar
                  labels={analytics.modules_usd_revenue_graphs_data.labels}
                  colour="#8B173B"
                  title={analytics.modules_usd_revenue_graphs_data.title}
                  label="Total Revenue (USD)"
                  datasets={
                    analytics.modules_usd_revenue_graphs_data.datasets || []
                  }
                />
              </div>
            )}
            {analytics?.modules_kes_revenue_graphs_data && (
              <div className={`${CHART_CARD} h-[320px]`}>
                <VerticalBar
                  labels={analytics.modules_kes_revenue_graphs_data.labels}
                  colour="#8B173B"
                  title={analytics.modules_kes_revenue_graphs_data.title}
                  label="Total Revenue (KES)"
                  datasets={
                    analytics.modules_kes_revenue_graphs_data.datasets || []
                  }
                />
              </div>
            )}
            {analytics?.modules_enrollment_graph_data && (
              <div className={`${CHART_CARD} h-[420px] xl:col-span-2`}>
                <VerticalBar
                  labels={analytics.modules_enrollment_graph_data.labels}
                  colour="#00999E"
                  title={analytics.modules_enrollment_graph_data.title}
                  label="Number of Students"
                  datasets={
                    analytics.modules_enrollment_graph_data.datasets || []
                  }
                />
              </div>
            )}
          </div>
        </>
      )}
    </AnalyticsPageLayout>
  );
}

export default PaidModulesAnalytics;
